"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LANGUAGE_COOKIE_OPTIONS = exports.LANGUAGE_COOKIE_KEY = void 0;
/**
 * Name of the cookie we want to store current selected language.
 */
const LANGUAGE_COOKIE_KEY = exports.LANGUAGE_COOKIE_KEY = 'lang';

/**
 * Options to be used when setting cookies.
 */
const LANGUAGE_COOKIE_OPTIONS = exports.LANGUAGE_COOKIE_OPTIONS = {
  expires: 365 // days
};
